<template>
  <div class="KBMoney"
       :class="{ 'KBMoney--seamless': seamless && !focused }">
    <input type="text"
           ref="input"
           v-money="money"
           v-model="text"
           :key="rerender"
           :placeholder="placeholder"
           @input="input"
           @keyup.enter="save"
           @focus="focused = true"
           @blur="focused = false"
           :class="{ 'input--dark': $vuetify.theme.dark && seamless }"
           :disabled="disabled"/>
    <span v-if="currency">{{currency}}</span>
  </div>
</template>
<script>
import { VMoney } from 'v-money'
export default {
  props: ['value', 'placeholder', 'currency', 'seamless', 'disabled', 'autofocus'],
  mounted () {
    setTimeout(() => {
      if (this.value) this.text = this.value + '00'
      if (this.autofocus) this.$refs.input.focus()
      this.rerender++
    }, 500)
  },
  data () {
    return {
      rerender: 0,
      text: this.value + '00',
      focused: false,
      money: {
        decimal: ',',
        thousands: '',
        prefix: '$',
        suffix: '',
        masked: true
      }
    }
  },
  methods: {
    input () {
      let text = this.text.substring(0, this.text.length - 2)
      text = text.replace('.', '').replace(',', '').replace('$', '')
      if (text !== '0') this.$emit('input', text)
    },
    save () {
      let text = this.text.substring(0, this.text.length - 2)
      text = text.replace('.', '').replace(',', '').replace('$', '')
      this.$emit('save', text)
    }
  },
  directives: {
    money: VMoney
  }
}
</script>
<style scoped lang="scss">
.KBMoney {
  background: rgba(182, 190, 199, 0.2);
  height: 53px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 30px;
  caret-color: #01CFE4;
  transition: background 0.4s ease;
  input {
    height: 31px;
    width: 100%;
    outline: none;
    font-size: 0.875rem;
  }

  span {
    font-size: 0.875rem;
  }
}
.KBMoney--seamless {
  background: rgba(182, 190, 199, 0.18);
}

.KBMoney--seamless:hover {
  background: rgba(182, 190, 199, 0.2);
}

.input--dark {
  color: $simple-grey;
}
</style>
